import React from 'react';
import { Tabs, Tab, Paper, Typography, Box, makeStyles } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import ServiceParticipant from './ServiceParticipant';
import ServiceParticipantProvider from './ServiceParticipantProvider';
const useStyles = makeStyles(theme => ({
  tab: {
    borderBottomStyle: 'none !important' as 'none'
  }
}));

interface TabPanelProps {
  children: React.ReactNode;
  value: string;
  index: string;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
      {value === index && <Box>{children}</Box>}
    </Typography>
  );
}

interface ServiceTabsProps {
  providerData: providerInfo;
  data: serviceInfo;
  workflow: string;
}

type providerInfo = {
  [key: string]: any;
};

type serviceInfo = {
  [key: string]: any;
};
const ServiceTabs = (props: ServiceTabsProps) => {
  const classes = useStyles();
  let { detailTab } = useParams();
  let tab = 'customers';
  if (detailTab) {
    tab = detailTab;
  }
  const [value, setValue] = React.useState(tab);
  const handleChange = (_event: React.ChangeEvent<{}>, newValue: string) => {
    window.history.pushState('', '', '/service/' + props.workflow + '/' + newValue);
    setValue(newValue);
  };

  return (
    <Paper variant="outlined">
      <Tabs data-id="tabs" value={value} onChange={handleChange}>
        <Tab label="Customers" className={classes.tab} value="customers" />
        {/* <Tab label="Users" className={classes.tab} value="user" /> */}
        <Tab label="Providers" className={classes.tab} value="providers" />
      </Tabs>
      <TabPanel value={value} index="providers">
        <ServiceParticipantProvider providerData={props.providerData} />
      </TabPanel>
      <TabPanel value={value} index="customers">
        <ServiceParticipant data={props.data} />
      </TabPanel>
    </Paper>
  );
};

export default ServiceTabs;
